import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAuth from 'customHook/useAuth';

const SocketProvider = ({ children, url }) => {
  const dispatch = useDispatch();
  const { connected, connecting }= useSelector((state) => state.socketReducer);
  const { validToken } = useAuth();

  useEffect(() => {
    if (validToken) {
      if (!connected && !connecting) {
        dispatch({
          type: 'socket/connect',
          payload: { url, auth: { token: validToken } }
        });
      }
    } else {
      dispatch({ type: 'socket/disconnect' });
    }
  }, [dispatch, connected, connecting, url, validToken]);

  useEffect(() => {
    return () => {
      dispatch({ type: 'socket/disconnect' });
    };
  }, [dispatch]);

  return children;
};

export default SocketProvider;